export default [
    {
        path: 'home',
        meta: {title: '我的主页'},
        component: () => import('../views/Home.vue')
    },
    /**
     * 网络门诊
     */
    {
        path: 'online',
        meta: {title: '今日网络门诊'},
        component: () => import('../views/Online.vue')
    },
    {
        path: 'online/week',
        meta: {title: '未来七天订单'},
        component: () => import('../views/online/Week.vue')
    },
    {
        path: 'online/history',
        meta: {title: '历史订单'},
        component: () => import('../views/online/History.vue')
    },
    /**
     * @query.id
     */
    {
        path: 'online/detail',
        meta: {title: '订单详情'},
        component: () => import('../views/online/Detail.vue')
    },
    /**
     * 全科分诊
     */
    {
        path: 'gp',
        meta: {title: '全科分诊'},
        component: () => import('../views/Gp.vue')
    },
    /**
     * 图文咨询
     */
    {
        path: 'consult',
        meta: {title: '图文咨询'},
        component: () => import('../views/Consult.vue')
    },
    /**
     * 远程预约
     * */
    {
        path: 'registration',
        meta: {title: '选择医院'},
        component: () => import('../views/appointment/HosSelect.vue')
    },
    {
        path: 'registration/department',
        meta: {title: '选择科室'},
        component: () => import('../views/appointment/DeptSelect.vue')
    },
    {
        path: 'registration/schedule',
        meta: {title: '科室排班'},
        component: () => import('../views/appointment/DeptSchedule.vue')
    },
    {
        path: 'registration/num',
        meta: {title: '选择号源'},
        component: () => import('../views/appointment/NumList.vue')
    },
    {
        path: 'registration/check',
        meta: {title: '挂号信息确认'},
        component: () => import('../views/appointment/Check.vue')
    },
    /**
     * 远程会诊
     */
    {
        path: 'consultation/launch',
        meta: {title: '会诊申请', type: 'init'},
        component: () => import('../views/consultation/Launch.vue')
    },
    {
        path: 'consultation/receive',
        meta: {title: '会诊安排', type: 'accept'},
        component: () => import('../views/consultation/Launch.vue')
    },
    {
        path: 'consultation/list',
        meta: {title: '远程会诊'},
        component: () => import('../views/consultation/List.vue')
    },
    /**
     * @query.type 发起的|收到的
     * @param.id
     */
    {
        path: 'consultation/detail/:id',
        meta: {title: '会诊详情'},
        component: () => import('../views/consultation/Detail.vue')
    },
    {
        path: 'consultation/statistics',
        meta: {title: '会诊统计'},
        component: () => import('../views/consultation/Statistics.vue')
    },
    {
        path: 'consultation/apply',
        meta: {title: '机构会诊申请'},
        component: () => import('../views/consultation/Apply.vue')
    },
    {
        path: 'consultation/report/:id',
        meta: {title: '会诊单'},
        component: () => import('../views/consultation/report')
    },

    /**
     * 门诊转诊和住院转诊
     * @param.type [outpatient|hospitalization]
     */
    {
        path: 'referral/:type/launch',
        meta: {title: '转诊申请', type: 'init'},
        component: () => import('../views/Referral.vue')
    },
    {
        path: 'referral/:type/receive',
        meta: {title: '转诊安排', type: 'accept'},
        component: () => import('../views/Referral.vue')
    },
    {
        path: 'referral/:type/list',
        meta: {title: '转诊', type: 'init'},
        component: () => import('../views/referral/List.vue')
    },
    {
        path: 'referral/:type/statistics',
        meta: {title: '转诊统计'},
        component: () => import('../views/referral/Statistics.vue')
    },
    {
        path: 'referral/:type/apply',
        meta: {title: '转诊申请', type: 'apply'},
        component: () => import('../views/referral/Apply.vue')
    },
    {
        path: 'referral/detail/:id',
        meta: {title: '转诊详情', type: 'detail'},
        component: () => import('../views/referral/Detail.vue')
    },
    {
        path: 'referral/:type/report/:id',
        meta: {title: '转诊详情'},
        component: () => import('../views/referral/report.vue')
    },
    /**
     * 慢病
     */
    {
        path: 'renewal',
        meta: {title: '慢病续方'},
        component: () => import('../views/Renewal.vue')
    },

    {
        path: 'diagnose/:type',
        meta: {title: '远程诊断'},
        component: () => import('../views/Dignose.vue')
    },
    {
        path: 'diagnose/:type/apply',
        meta: {title: '远程诊断申请'},
        component: () => import('../views/dignose/Apply.vue')
    },
    {
        path: 'diagnose/:type/report',
        meta: {title: '远程诊断报告书写'},
        component: () => import('../views/dignose/Report.vue')
    },
    {
        path: 'diagnose/:type/detail',
        meta: {title: '远程诊断报告详情'},
        component: () => import('../views/dignose/Detail.vue')
    },
    /**
     * 远程教育
     */
    {
        path: 'edu',
        meta: {title: '远程教育'},
        component: () => import('../views/Edu.vue')
    },
    {
        path: 'edu/start',
        meta: {title: '即将开始'},
        component: () => import('../views/Edu.vue')
    },
    {
        path: 'blank',
        meta: {title: '正在开发中'},
        component: () => import('../views/Blank.vue')
    },
    /**
     * 直播管理
     */
    {
        path: 'live/list',
        meta: {title: '直播列表'},
        component: () => import('../views/live/List.vue')
    },
    {
        path: 'live/my',
        meta: {title: '我的直播'},
        component: () => import('../views/live/My.vue')
    },
    /**
     * @query.room
     */
    {
        path: 'live/detail',
        meta: {title: 'detail'},
        component: () => import('../views/live/Detail.vue')
    },
    /**
     * 检查转诊和手术转诊
     * @param.type [check|]
     */
    {
        path: 'referral/hos/:type/launch',
        meta: {title: '转诊申请', type: 'init'},
        component: () => import('../views/hos/list.vue')
    },
    {
        path: 'referral/hos/:type/receive',
        meta: {title: '转诊安排', type: 'accept'},
        component: () => import('../views/hos/list.vue')
    },
    {
        path: 'referral/hos/:type/statistics',
        meta: {title: '转诊统计'},
        component: () => import('../views/hos/statistics.vue')
    },
    {
        path: 'referral/hos/:type/apply',
        meta: {title: '转诊申请'},
        component: () => import('../views/hos/apply.vue')
    },
    {
        path: 'referral/hos/:type/detail/:id',
        meta: {title: '转诊申请'},
        component: () => import('../views/hos/detail.vue')
    },
    {
        path: 'referral/hos/:type/report/:id',
        meta: {title: '转诊申请'},
        component: () => import('../views/hos/report.vue')
    },
    /***
     *  远程门诊
     */
    {
        path: 'referral/dis/distance/launch',
        meta: {title: '远程门诊申请'},
        component: () => import('../views/distance/list.vue')
    },
    {
        path: 'referral/dis/distance/receive',
        meta: {title: '今日远程门诊'},
        component: () => import('../views/distance/receive.vue')
    },
    {
        path: 'referral/dis/distance/appointment',
        meta: {title: '预约远程门诊'},
        component: () => import('../views/distance/appointment.vue')
    },
    {
        path: 'referral/dis/distance/week',
        meta: {title: '未来几天远程门诊'},
        component: () => import('../views/distance/Week.vue')
    },
    {
        path: 'referral/dis/distance/history',
        meta: {title: '历史记录'},
        component: () => import('../views/distance/History.vue')
    },
    /**
     * 药事服务
     */
    {
        path: "pharmacy-workstation",
        meta: {title: '药房工作站'},
        component: () => import("../views/pharmacy-workstation/list.vue")
    },
    {
        path: "pharmacy-order",
        meta: {title: '订单管理'},
        component: () => import("../views/pharmacy-workstation/order")
    },
    {
        path: "produce-order",
        meta: {title: '外材管理'},
        component: () => import("../views/pharmacy-workstation/produce")
    },
    {
        path: "pharmacy-drugs",
        meta: {title: '药房药品'},
        component: () => import("../views/pharmacy-drugs/list.vue")
    },
    /*{
        path: "e-prescription",
        meta: {title: '开处方'},
        component: () =>import("../views/prescription-management/EPrescription")
    },*/
    {
        path: "prescription-list",
        meta: {title: '处方列表'},
        component: () => import("../views/prescription-management/PrescriptionList")
    },
    {
        path: "prescription-check",
        meta: {title: '处方审核列表'},
        component: () => import("../views/prescription-management/PrescriptionCheck")
    },
    {
        path: "usedrecipe-list",
        meta: {title: '常用方管理'},
        component: () => import("../views/used-recipe/used-list")
    },
    {
        path: "usedrecipe-detail",
        meta: {title: '常用方维护'},
        component: () => import("../views/used-recipe/used-detail")
    },
]
